// extracted by mini-css-extract-plugin
module.exports = {"Button":"OutlineButton_Button__3HBUa","Link":"OutlineButton_Link__TZSVT","FullWidth":"OutlineButton_FullWidth__1p-ut"};